import { render, staticRenderFns } from "./energyBox.vue?vue&type=template&id=4e9fa600&scoped=true"
import script from "./energyBox.vue?vue&type=script&lang=js"
export * from "./energyBox.vue?vue&type=script&lang=js"
import style0 from "./energyBox.vue?vue&type=style&index=0&id=4e9fa600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9fa600",
  null
  
)

export default component.exports